import { defineStore } from "pinia";
import { CalendarModel } from "@/services/entities/Reporting/CalendarModel";
import CalendarDataFetcher from "@/services/connectors/calendarConnector";
import { getServerUrl } from "@/common/urls";
import {
  showToastError,
} from "@/toastification";

const calendar = new CalendarDataFetcher(getServerUrl());

export const useCalendarStore = defineStore("calendar", {
  state: () => ({
    calendar: {
      data: {} as CalendarModel,
      loader: false,
    },
  }),
  actions: {
    async loadCalendarMonth(
      year: number,
      month: number,
      userId: string
    ): Promise<void> {
      try {
        this.calendar.loader = false;
        this.calendar.data = {} as CalendarModel;
        this.calendar.data = await calendar.getCalendarReport(
          year,
          month,
          userId
        );
      } catch (e: any) {
        showToastError("Failed to load calendar data: " + e.message);
        console.error(e);
      } finally {
        this.calendar.loader = true;
      }
    },

    async loadCalendarMonthOData({ year, month, userId }: { year: number, month: number, userId: string }): Promise<void> {
      try {
        this.calendar.loader = false;
        const result = await calendar.getCalendarReport(year, month, userId);
        this.calendar.data = result.data;
      } catch (e: any) {
        showToastError("Failed to load calendar data: " + e.message);
        console.error(e);
      } finally {
        this.calendar.loader = true;
      }
    },
  },
  getters: {
    getAll(): CalendarModel {
      return this.calendar.data;
    },
    getAllLoaded(): boolean {
      return !this.calendar.loader;
    },
  },
});
